import React from "react";

function RecordLabel(props) {
  return (
    <svg
      width="57"
      height="29"
      viewBox="0 0 57 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="7.49121"
        width="2.33607"
        height="14.0164"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="6.07373"
        y="5.15527"
        width="2.33607"
        height="18.6885"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="12.1475"
        y="0.483398"
        width="2.33607"
        height="28.0328"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="18.2212"
        y="5.15527"
        width="2.33607"
        height="18.6885"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="24.2949"
        y="7.49121"
        width="2.33607"
        height="14.0164"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="30.3687"
        y="5.15527"
        width="2.33607"
        height="18.6885"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="36.4424"
        y="0.483398"
        width="2.33607"
        height="28.0328"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="42.5166"
        y="5.15527"
        width="2.33607"
        height="18.6885"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="48.5903"
        y="7.49121"
        width="2.33607"
        height="14.0164"
        rx="1.16803"
        fill="#0C8CE9"
      />
      <rect
        x="54.6641"
        y="11.6963"
        width="2.33607"
        height="5.60656"
        rx="1.16803"
        fill="#0C8CE9"
      />
    </svg>
  );
}

export default RecordLabel;
